import React from "react";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
  DataCardContent,
  DataItem,
  DataLabel,
  DataValue,
  AmountValue,
  ISOHeader,
  ISOHeaderTitle,
  // ISOHeaderSubtitle,
} from "./PeriodicIso.styles";
import { AccountBalance, AttachMoney, Receipt } from "@mui/icons-material";

const PeriodicIsoBaseData = (props) => {
  const { isoID, isoName, consolidatedData } = props;

  // Función para formatear números con separadores de miles
  const formatNumber = (value) => {
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num)
        ? value
        : num.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          });
    }
    return value?.toLocaleString("en-US") || "0";
  };

  // Función para determinar si un monto es positivo o negativo
  const isPositiveAmount = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num >= 0;
  };

  return (
    <GridContainer>
      {/* ISO Header */}
      <GridItem xs={12}>
        <ISOHeader>
          <ISOHeaderTitle>ISO Details</ISOHeaderTitle>
        </ISOHeader>
      </GridItem>

      {/* ISO Information Card */}
      <GridItem xs={12} padding="15px">
        <DataCard>
          <DataCardHeader>
            <AccountBalance color="primary" />
            <DataCardTitle>ISO Information</DataCardTitle>
          </DataCardHeader>
          <DataCardContent>
            <DataItem>
              <DataLabel>ISO ID</DataLabel>
              <DataValue>{isoID || "N/A"}</DataValue>
            </DataItem>
            <DataItem>
              <DataLabel>ISO Name</DataLabel>
              <DataValue>{isoName || "N/A"}</DataValue>
            </DataItem>
          </DataCardContent>
        </DataCard>
      </GridItem>

      {/* Transaction Summary Card */}
      <GridItem xs={12} md={6} padding="15px">
        <DataCard>
          <DataCardHeader>
            <Receipt color="primary" />
            <DataCardTitle>Transaction Summary</DataCardTitle>
          </DataCardHeader>
          <DataCardContent>
            <DataItem>
              <DataLabel>Transaction Count</DataLabel>
              <DataValue>{consolidatedData?.transactionsCount || 0}</DataValue>
            </DataItem>
            <DataItem>
              <DataLabel>Amount</DataLabel>
              <DataValue>
                ${formatNumber(consolidatedData?.transactionsAmount || "0")}
              </DataValue>
            </DataItem>
          </DataCardContent>
        </DataCard>
      </GridItem>

      {/* Financial Amounts Card */}
      <GridItem xs={12} md={6} padding="15px">
        <DataCard>
          <DataCardHeader>
            <AttachMoney color="primary" />
            <DataCardTitle>Summary</DataCardTitle>
          </DataCardHeader>
          <DataCardContent>
            <DataItem>
              <DataLabel>Settlement</DataLabel>
              <AmountValue
                positive={isPositiveAmount(consolidatedData?.amountDue)}
              >
                ${formatNumber(consolidatedData?.amountDue || "0")}
              </AmountValue>
            </DataItem>
            <DataItem>
              <DataLabel>Processing Fee</DataLabel>
              <DataValue>
                ${formatNumber(consolidatedData?.txProcessing || "0")}
              </DataValue>
            </DataItem>
            <DataItem>
              <DataLabel>MDR Fee</DataLabel>
              <DataValue>
                ${formatNumber(consolidatedData?.txMDR || "0")}
              </DataValue>
            </DataItem>
          </DataCardContent>
        </DataCard>
      </GridItem>
    </GridContainer>
  );
};

export default PeriodicIsoBaseData;
